import { render, staticRenderFns } from "./ReturnAddress.vue?vue&type=template&id=ed680734&"
import script from "./ReturnAddress.vue?vue&type=script&lang=ts&"
export * from "./ReturnAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports